import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
    Accordion, AccordionDetails, AccordionSummary, Box, Paper,
    Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography,
} from "@mui/material"
import { Control, Controller } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { IOrder } from "./types"

export default function GeneralInfoSection({ control }: { control: Control<IOrder> }) {
    const { t } = useTranslation()

    return (
        <Accordion defaultExpanded disableGutters variant="outlined" sx={{ mb: 2, "&:before": { display: "none" } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2 }}>
                <Typography sx={{ fontWeight: "bold" }}>{t("orders.form.generalInfo")}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 2, pb: 2 }}>
                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(5, 1fr)" }, gap: 2, mb: 2 }}>
                    <Controller control={control} name="final_product_weight_per_roll"
                        render={({ field }) => <TextField {...field} label={t("orders.form.weightPerRoll")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="final_product_weight_per_core"
                        render={({ field }) => <TextField {...field} label={t("orders.form.weightPerCore")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="general_info_requested_amount"
                        render={({ field }) => <TextField {...field} label={t("orders.form.requestedAmount")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="general_info_waste_percentage"
                        render={({ field }) => <TextField {...field} label={t("orders.form.wastePercent")} size="small" type="number" fullWidth />}
                    />
                    <Controller control={control} name="general_info_refile_percentage"
                        render={({ field }) => <TextField {...field} label={t("orders.form.refilePercent")} size="small" type="number" fullWidth />}
                    />
                </Box>
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell variant="head">{t("orders.form.minThousandWeight")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_thousand_weight_min" render={({ field: { value } }) => <span>{Number(value).toFixed(2)} grs.</span>} /></TableCell>
                                <TableCell variant="head">{t("orders.form.maxThousandWeight")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_thousand_weight_max" render={({ field: { value } }) => <span>{Number(value).toFixed(2)} grs.</span>} /></TableCell>
                                <TableCell variant="head">{t("orders.form.programmedKgs")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_programmed_kilograms" render={({ field: { value } }) => <span>{Number(value).toFixed(2)} kgs.</span>} /></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head">{t("orders.form.waste")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_waste" render={({ field: { value } }) => <span>{Number(value).toFixed(4)}</span>} /></TableCell>
                                <TableCell variant="head">{t("orders.form.refile")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_refile" render={({ field: { value } }) => <span>{Number(value).toFixed(4)}</span>} /></TableCell>
                                <TableCell variant="head">{t("orders.form.total")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_programmed_total" render={({ field: { value } }) => <span>{Number(value).toFixed(2)} kgs.</span>} /></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head">{t("orders.form.rolls")}</TableCell>
                                <TableCell><Controller control={control} name="general_info_rolls_amount" render={({ field: { value } }) => <span>{Number(value).toFixed(4)} rolls</span>} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </AccordionDetails>
        </Accordion>
    )
}
